<template>
	<v-menu location="bottom end" offset="8" :close-on-content-click="true">
		<template #activator="{ props: activatorProps }">
			<v-btn icon variant="text" v-bind="activatorProps" :class="{ 'nav-user-menu--delegation': delegation }" :title="userName" :aria-label="userName">
				<v-icon>{{ delegation ? 'group' : 'account_circle' }}</v-icon>
			</v-btn>
		</template>
		<v-list class="nav-user-menu" rounded="xl" min-width="260">
			<v-list-item :disabled="Boolean(delegation)" prepend-icon="manage_accounts" :title="userName" :subtitle="delegation || userLogin" @click="emit('action', 'profile')" />
			<template v-if="!delegation">
				<v-list-item v-if="onApp" prepend-icon="sync" :title="t('Synchronize')" @click="emit('action', 'synchronize')" />
				<v-list-item v-if="onApp && points" prepend-icon="paid" :title="t('YourPoints')" :subtitle="`${points} ${t('pts')}`" @click="emit('action', 'pointsHistory')" />
				<template v-if="onApp && widgetSettings">
					<v-list-item prepend-icon="widgets" :title="t('WidgetsSettings')" @click="emit('action', 'widgetSettings')" />
					<v-list-item prepend-icon="dashboard_customize" :title="t('OldWidgetsSettings')" @click="emit('action', 'legacyWidgetSettings')" />
				</template>
				<v-list-item prepend-icon="release_alert" :title="t('ReleaseNote')" @click="emit('action', 'releaseNotes')" />
				<v-list-item prepend-icon="support_agent" :title="t('ExternisSupport')" @click="emit('action', 'support')" />
				<v-list-item v-if="extensionUpdate" prepend-icon="extension" :title="t('UpdateNeeded')" @click="emit('action', 'extensionUpdate')" />
			</template>
			<v-divider class="my-1" />
			<v-list-item prepend-icon="logout" :title="t('Logout')" :subtitle="synchronizing ? t('PleaseWaitSync') : undefined" :disabled="synchronizing" @click="emit('action', 'logout')" />
		</v-list>
	</v-menu>
</template>

<script setup>
import { useTranslator } from '@/composables/useTranslator';

defineProps({
	userName: { type: String, default: '' },
	userLogin: { type: String, default: '' },
	delegation: { type: String, default: null },
	onApp: { type: Boolean, default: false },
	extensionUpdate: { type: Boolean, default: false },
	points: { type: String, default: null },
	widgetSettings: { type: Boolean, default: false },
	synchronizing: { type: Boolean, default: false },
});
const emit = defineEmits(['action']);

const t = useTranslator();
</script>
